<div class="container">
  <div class="sidebar">
    <!-- Left Side bar content -->
  </div>

  <div class="content" [ngClass]="{ 'hide-dealer-image': dealerImageDisplay }" (swipeleft)="onSwipeLeft($event)" (swiperight)="onSwipeRight($event)">
    @if(!isLargeScreen){
    <div class="header">
      <h4 i18n>Service Order</h4>
    </div>

    <div class="desription">
      <p i18n>These are repair jobs in your vehicle. Pending requests require your authorization.</p>
    </div>
    }
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="selectTab($event)" fitInkBarToContent>
      <mat-tab [label]="pendingTabLabel"></mat-tab>
      <mat-tab label="Authorized" i18n-label></mat-tab>
      <mat-tab label="Declined" i18n-label></mat-tab>
    </mat-tab-group>

    <div class="scrollable-section">
      @if (serviceOrderServiceJobs.length != 0) {
      @for (job of serviceOrderServiceJobs; track job?.id || i; let i = $index) {
      <div class="card">
        <div class="card-content">
          <div class="card-heading">
            @if (!job.checkpoints && job.description) {
            <h3>{{ job.description }}</h3>
            <span>{{job.descriptionLong}}</span>
            }

            @if (job.checkpoints && job.checkpoints.length != 0) {
            <h3>{{ job.checkpoints[0].description }}</h3>
            <span>{{job.descriptionLong}}</span>
            }

            @for (checkpoint of job?.checkpoints; track checkpoint?.id || j; let j = $index) {
            @if (checkpoint.findings.length != 0) {
            @for (findings of checkpoint.findings; track findings?.id || k; let k = $index) {
            @if (findings.findingType != null) {
            <div>{{ findings.findingType.description }}</div>
            }
            }
            }
            @if (checkpoint?.measuredValues && checkpoint.findings.length === 0) {
            <div>{{ checkpoint?.measuredValues[0]?.value}}</div>
            }             
            }
          </div>

          <div class="image">
            @for (checkpoint of job.checkpoints; track checkpoint?.id || j; let j = $index) {
            @if (checkpoint?.media?.length) {
            <app-media-carousel [media]="checkpoint.media" [id]="'checkpoint-' + i + '-' + j"
              [isWalkthroughEnabled]="job.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
            </app-media-carousel>
            } @else if (checkpoint?.measuredValues?.[0]?.media?.length && !hasFindingMedia(checkpoint)) {
            <app-media-carousel [media]="checkpoint.measuredValues[0].media" [id]="'checkpoint-' + i + '-' + j + '-mv'"
              [isWalkthroughEnabled]="job.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
            </app-media-carousel>
            }

            @if (checkpoint.findings?.length) {
            @for (finding of checkpoint.findings; track finding?.id || k; let k = $index) {
            @if (finding.media?.length) {
            <app-media-carousel [media]="finding.media" [id]="'finding-' + i + '-' + j + '-' + k"  [isWalkthroughEnabled]="job.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData"></app-media-carousel>
            }
            }
            }
            }
          </div>

        </div>

        <div class="job-card">
          <div class="card-job-content">

            @for (checkpoint of job?.checkpoints; track checkpoint?.id || j; let j = $index) {
            @if (checkpoint.findings.length != 0) {
            @for (findings of checkpoint.findings; track findings?.id || k; let k = $index) {
            @if (findings.findingType != null) {
            <div>{{ findings.solution.description }}</div>
            <div>{{ findings.comment }}</div>
            }
            }
            }
            }

            @if (job.checkpoints && job.checkpoints.length != 0) {
            <div>{{ job.description }}</div>
            }

            <div class="price-details">
              @if (job.priceSummary?.length != 0) {
              @for (price of job.priceSummary; track price?.id || l; let l = $index) {
              <div>
                <span>{{ priceTypeLabel(price?.type)}}</span>
                <span>{{ price?.price?.netPrice | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
              </div>
              }
              }

              <div>
                <span i18n>Discount</span>
                <span>{{ getTotalDiscount(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
              </div>

              <div>
                <span i18n="@@totalInclTax">Total incl. tax ({{ getTotalTaxes(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }})</span>
                <span class="total">{{ getTotalGrossPrice(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
              </div>
            </div>

            @if (job) {
            <div class="actions">
              @if (job?.approvalStatus !== Approvalstatus.Accept) {
              @if (job?.approvalStatus !== Approvalstatus.Reject) {
              <button mat-button class="decline" (click)="onButtonGroupClick(Approvalstatus.Reject,job)" i18n>
                Decline
              </button>
              } @else {
              <button mat-button class="decline" disabled i18n>
                Declined
              </button>
              }
              }

              @if (job?.approvalStatus !== Approvalstatus.Reject) {
              @if (job?.approvalStatus !== Approvalstatus.Accept) {
              <button mat-button color="primary" class="authorize"
                (click)="onButtonGroupClick(Approvalstatus.Accept,job)" i18n>
                Authorize
              </button>
              } @else {
              <button mat-button color="primary" class="authorize" disabled i18n>
                Authorized
              </button>
              }
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
      }
      @if(serviceOrderServiceJobs?.length === 0){
      <div class="no-data-wrapper">
        <div class="no-data-container">
          <img src="assets/logo/search_off.jpg" alt="No jobs are Available" />
          <div class="no-jobs-container">
            <h3>{{ getNoJobsMessage().title }}</h3>
            <p>{{ getNoJobsMessage().description }}</p>
          </div>
        </div>
      </div>
      }

    </div>
  </div>

  @if(showFooter){
  <div class="footer">
    <div class="footer-content">
      @if (showDeclineButton && !isAuthorized) {
      <button class="decline-all-button" color="primary" mat-raised-button [disabled]="isDeclineDisabled"
        [ngClass]="{'disabled-button': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}"
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)">
        <span class="button-content">
          <mat-icon>close</mat-icon>
          <span i18n>Decline all</span>
        </span>
      </button>
      }

      @if (!isAuthorized) {
      <button class="request-callback-button" color="primary" mat-raised-button
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
        <span class="button-content">
          <img src="../../assets/common/request_callback.png"  class="request_callback_image"/>
          <span class="callback-text" i18n>Request Callback</span>
        </span>
      </button>
      }

      @if (showAuthorizeButton) {
      <button class="button-authorize" color="primary" mat-raised-button [disabled]="isAuthorizeDisabled"
      [ngClass]="{'disabled-button': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}"
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)">
        <span class="button-content">
          <mat-icon>check</mat-icon>
          <span i18n>Authorize all</span>
        </span>
      </button>
      }
    </div>


    <div class="action-bar-container responsive-actions">
      @if (!isAuthorized) {
      <button class="floating-center-btn" (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
        <img src="../../assets/common/callback.png" />
      </button>
      }

      <div class="action-bar">
        @if (showDeclineButton && !isAuthorized) {
        <button mat-button class="decline-btn" 
        [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1" (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)"
          [ngClass]="{'text-disabled': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}">
          <span class="button-content">
            <mat-icon>close</mat-icon>
            <span i18n>Decline all</span>
          </span>
        </button>
        }

        @if (showAuthorizeButton) {
        <button mat-button class="authorize-btn"  [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1"
          (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)"
          [ngClass]="{'text-disabled': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}">
          <span class="button-content">
            <mat-icon>check</mat-icon>
            <span i18n>Authorize all</span>
          </span>
        </button>
        }
      </div>
    </div>
  </div>
}
</div>